import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Public Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/ProgramsPage';
import ScholarshipPage from './pages/ScholarshipPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import KVKKPage from './pages/KVKKPage';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminApplications from './pages/admin/AdminApplications';
import AdminExams from './pages/admin/AdminExams';
import AdminContent from './pages/admin/AdminContent';
import AdminGallery from './pages/admin/AdminGallery';
import AdminSettings from './pages/admin/AdminSettings';

// Components
import Layout from './components/Layout';
import AdminLayout from './components/admin/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="hakkimizda" element={<AboutPage />} />
        <Route path="programlar" element={<ProgramsPage />} />
        <Route path="bursluluk" element={<ScholarshipPage />} />
        <Route path="galeri" element={<GalleryPage />} />
        <Route path="iletisim" element={<ContactPage />} />
        <Route path="gizlilik-politikasi" element={<PrivacyPolicyPage />} />
        <Route path="kvkk" element={<KVKKPage />} />
      </Route>

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<AdminDashboard />} />
        <Route path="basvurular" element={<AdminApplications />} />
        <Route path="sinavlar" element={<AdminExams />} />
        <Route path="icerik" element={<AdminContent />} />
        <Route path="galeri" element={<AdminGallery />} />
        <Route path="ayarlar" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}

export default App;

